import {Box, createStyles, Link, makeStyles, Typography} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import React, {memo, useEffect, useState} from 'react';
import {BasicCard} from '../../view/components/default-components/basic-card/basic-card';
import {TitleAndSubCard} from '../../view/components/default-components/title-and-sub-card';
import {localized} from '../../i18n/i18n';
import {warningIconColor} from '../../styles/color-constants';
import {routes} from '../../state/routes';
import {useLocation} from 'react-router-dom';

const hrefMailToCustomerService = 'mailto:' + localized('KundeServiceMail');
const warningSites = [routes.documents, routes.contracts];

export const PageWarningMessage = memo(() => {
  const classes = useStyles();
  const location = useLocation();
  const [showWarningOnPage, setShowWarning] = useState(false);

  useEffect(() => {
    warningSites.includes(location.pathname) && setShowWarning(true);
  }, []);

  if (!showWarningOnPage) return <></>;

  return (
    <BasicCard>
      <Box className={classes.flexBox}>
        <WarningIcon className={classes.warningIcon} />
        <TitleAndSubCard title={localized('WarningTemporaryDataErrorTitle')} titleAlign="center" />
      </Box>
      <Typography className={classes.text}>
        {localized('WarningTemporaryDataErrorMessage') + ' '}
        <Link variant={'body1'} href={hrefMailToCustomerService} target="_blank" rel="noopener noreferrer">
          {localized('KundeServiceMail')}
        </Link>
      </Typography>
    </BasicCard>
  );
});

const useStyles = makeStyles(() =>
  createStyles({
    warningIcon: {
      color: warningIconColor,
      marginRight: 10,
      fontSize: 30,
    },
    flexBox: {
      display: 'flex',
      marginBottom: 5,
    },
    text: {
      whiteSpace: 'pre-line', // This enables line breaks from \n
    },
  }),
);
